import Vue from 'vue'
import VueRouter from 'vue-router'

//Parametre
import Parametre from '../views/parametres/type-article/index.vue'
import ItemType from '../views/item-type/index.vue'
import AjoutType from '../views/ajout-type/index.vue'

//Medicament
import Medicament from '../views/medicaments/'
import AjoutMedicament from '../views/medicaments/ajout-medicament/index.vue'
import EditMedicament from '../views/medicaments/edit-medicament/index.vue'

//  consommables
import ListeConsommable from '../views/consommables/liste-consommable/index.vue'
import AjoutConsommable from '../views/consommables/ajout-consommable/index.vue'
import EditConsommable from '../views/consommables/edit-consommable/index.vue'

//Articles
import Article from '../views/articles/index.vue'
import AjoutArticle from '../views/ajout-article/index.vue'
import ViewArticle from '../components/view-article/index.vue'


//Fournisseur
import Fournisseur from '../views/fournisseurs/index.vue'
import AjoutFournisseur from '../views/fournisseurs/ajout-fournisseur/index.vue'
import ShowFournisseur from '../views/fournisseurs/show-fournisseur/index.vue'


//Gestion des stock
import Stock from '../views/stock/index.vue'
import AjoutStock from '../views/stock/ajout-stock/index.vue'
import ShowStock from '../views/stock/show-stock/index.vue'
import EchangeStock from '../views/stock/echange-stock/index.vue'
import HistoriqueDestockage from '../views/stock/historique-destockage'
import Destockage from '../views/stock/historique-destockage/destockage'
import RetourStock from '@/views/stock/confirm-retour-stock'
import SortieStock from '@/views/stock/stock-sorties'

//inventaires
import Inventaire from '../views/inventaire/index.vue'
import AjoutInventaire from '../views/ajout-inventaire/index.vue'
import ShowInventaire from '../views/show-inventaire/index.vue'

//Vente
import Vente from '../views/vente/index.vue'

import Commandes from '../views/commandes/index.vue'
import Profil from '@/views/parametres/profil'

import BlockedUI from '@/components/blocked-ui'

//Entre
import Entre from '../views/entres/index.vue'
import AjoutEntre from '../views/entres/ajout-entres/index.vue'
import Login from '@/views/login'


import store from '@/store'
import { stockLandingRoute } from '@/utils/stock-landing'


Vue.use(VueRouter)

const routes = [
    { path: '/vaccins', name: 'Vaccins', component: () => import('@/views/vaccins/index.vue') },
    { path: '/guide-utilisation', name: 'GuideUtilisation', component: () => import('@/views/guide-utilisation/index.vue') },
    {
        path: '/blocked',
        name: 'Access Denied',
        component: BlockedUI,
    },

    {
        path: "/",
        redirect: () => {
            const authInfo = store.getters['authInfo']
            return stockLandingRoute(authInfo && authInfo.user && authInfo.user.roles, store.getters['activeRole'])
        },
    },
    {
        path: "/espaces",
        name: "Espaces de stock",
        component: () => import('@/views/logistique-dashboard/index.vue'),
    },
    {
        path: "/clinicaa/stock",
        redirect: "/medicaments",
    },
    {
        path: "/medicaments",
        name: "medicament",
        component: Medicament,
    },

    {
        path: "/medicaments/edit/:id",
        name: "EditArticle",
        component: EditMedicament,
        props: true,
    },

    {
        path: "/medicaments/ajout",
        name: "Ajout-Medicament",
        component: AjoutMedicament,
    },

    /*
     *
     *     Consommable
     *
     * */

    {
        path: "/consommables",
        name: "Liste-Consommable",
        component: ListeConsommable,
    },
    {
        path: "/consommables/ajout",
        name: "Ajout-Consommable",
        component: AjoutConsommable,
    },
    {
        path: "/consommables/edit/:id",
        name: "Edit-Consommable",
        component: EditConsommable,
    },

    /*
     *
     *
     * Articles
     *
     * */
    {
        path: "/articles",
        name: "Article",
        component: Article,
    },

    {
        path: "/:article/view/:id",
        name: "ViewArticle",
        component: ViewArticle,
        props: true,
    },

    /*
     *
     *Stock
     *
     */
    {
        path: "/stock",
        name: "stock",
        component: Stock,
    },
    {
        path: "/stock/ajout",
        name: "AjoutStock",
        component: AjoutStock,
    },
    {
        path: "/stock/show/:id",
        name: "ShowStock",
        component: ShowStock,
    },

    {
        path: "/destockages",
        name: "HistoriqueDeDestockage",
        component: HistoriqueDestockage,
    },

    {
        path: "/destockages/ajout",
        name: "Destockage",
        component: Destockage,
    },

    {
        path: "/stock/echange/:id",
        name: "EchangeStock",
        component: EchangeStock,
    },

    {
        path: "/retour-stock",
        name: "RetourStock",
        component: RetourStock,
    },

    {
        path: "/sorties-de-stock",
        name: "SortieStock",
        component: SortieStock,
    },

    /**
     *
     * Vente
     */
    {
        path: "/ventes",
        name: "Vente",
        component: Vente,
    },
    {
        path: "/fournisseurs",
        name: "Fournisseur",
        component: Fournisseur,
    },
    {
        path: "/fournisseurs/ajout",
        name: "AjoutFournisseur",
        component: AjoutFournisseur,
    },
    {
        path: "/fournisseurs/show/:id",
        name: "ShowFournisseur",
        component: ShowFournisseur,
        props: true,
    },
    {
        path: "/parametres",
        name: "Parametre",
        component: Parametre,
    },
    {
        // Les unités de soins se gèrent dans Clinique → Paramètres → Équipe et Accès ;
        // la liste des stocks indique l'unité de chaque armoire.
        path: "/parametres/services-soins",
        redirect: "/stock",
    },
    {
        path: "/parametres/type/:id",
        name: "ItemType",
        component: ItemType,
    },
    {
        path: "/parametres/ajout-type",
        name: "AjoutType",
        component: AjoutType,
    },
    {
        path: "/articles/ajout",
        name: "AjoutArticle",
        component: AjoutArticle,
    },
    {
        path: "/type/:id",
        component: ItemType,
    },

    {
        path: "/commandes",
        name: "commandes",
        component: Commandes,
    },

    {
        path: "/inventaires",
        name: "inventaires",
        component: Inventaire,
    },
    {
        path: "/inventaires/ajout",
        name: "AjoutInventaire",
        component: AjoutInventaire,
    },
    {
        path: "/inventaires/demande",
        name: "DemandeInventaire",
        component: AjoutInventaire,
    },
    {
        path: "/inventaires/:id",
        name: "ShowInventaire",
        component: ShowInventaire,
    },
    {
        path: "/entres",
        name: "ShowEntres",
        component: Entre,
    },

    {
        path: "/entres/ajout",
        name: "AjoutEntres",
        component: AjoutEntre,
    },
    {
        path: "/login",
        name: "login",
        component: Login,
    },

    {
        path: "/parametres/profil",
        name: "Profil",
        component: Profil,
    },
];




const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    let access = false;
    let role;
    let role_actif;
    if (store.getters['authInfo']) {
        role = store.getters['authInfo'].user.roles
        access = false

        for (let index = 0; index < role.length; index++) {
            if (
                role[index].nom == "ROLE_PHARMACIEN" || role[index].nom == "ROLE_PHARMACIEN_INTERMITENT" ||
                role[index].nom == "ROLE_ADMINISTRATEUR" || role[index].nom == "ROLE_RESPONSABLE_LOGISTIQUE" || role[index].nom == "ROLE_RECEPTIONNISTE_INTERMITENT" || role[index].nom == "ROLE_RECEPTIONNISTE"
            ) {
                if (store.getters['activeRole']) {
                    role_actif = store.getters['activeRole'].nom
                    console.log("ROLES: ", role_actif.nom)
                    if (
                        role_actif != 'ROLE_PHARMACIEN_INTERMITENT' && role_actif != 'ROLE_PHARMACIEN' && role_actif != 'ROLE_ADMINISTRATEUR' && role_actif != 'ROLE_RESPONSABLE_LOGISTIQUE'
                    ) {
                        if (role[index].pivot.is_active != true || role[index].pivot.is_active != '1' || role[index].pivot.is_active != 1) {
                            store.dispatch('switchRole', { userId: store.getters['authInfo'].user.id, roleId: role[index].pivot.role_id })
                        }
                    }
                } else {
                    if (role[index].pivot.is_default == 1) {
                        store.dispatch('switchRole', { userId: store.getters['authInfo'].user.id, roleId: role[index].pivot.role_id })
                    }
                }

                access = true
            }

        }
    }
    if (!store.getters['authInfo'] && to.name != 'login') {
        router.push('/login')
    } else if (access === false && to.name != 'login') {
        router.push('/login')
    } else {
        // const user_info = store.getters['authInfo']

        // const can_login = user_info?.user.can_login
        // if (can_login && can_login == 1) {

            let countdown = {}
            store.dispatch('getCountDown').then((response) => {
                countdown = response
                if (countdown.is_count == 1 && countdown.duree_restant.days < 0) {
                    router.push('/blocked')
                } 
            })
        // }
        store.dispatch('getConfigInfoClinique', 'info_clinique')
        next()
    }

})

/**
 * Prevent right-click context menu.
 */
document.addEventListener('contextmenu', event => event.preventDefault());

/**
 * Prevent F12 key and other developer tool shortcuts.
 */
document.onkeydown = function (e) {
    // F12
    if (e.keyCode === 123) {
        return false;
    }
    // Ctrl+Shift+I
    if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
        return false;
    }
    // Add other shortcuts as needed
};

export default router
